import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import classNames from "classnames";
import { Ripple } from "primereact/ripple";
import { Badge } from "primereact/badge";
import { AppDB } from "./App";

// Recursive helper to find label by path
const findMenuLabelByPath = (items, path) => {
    for (const item of items) {
        if (item.to === path) return item.label;
        if (item.items) {
            const nested = findMenuLabelByPath(item.items, path);
            if (nested) return nested;
        }
    }
    return null;
};

const AppSubmenu = (props) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const onMenuItemClick = (event, item, index) => {
        if (item.disabled) {
            event.preventDefault();
            return;
        }

        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        setActiveIndex(index === activeIndex ? null : index);

        if (props.onMenuItemClick) {
            props.onMenuItemClick({
                originalEvent: event,
                item: item,
            });
        }
    };

    const onKeyDown = (event) => {
        if (event.code === "Enter" || event.code === "Space") {
            event.preventDefault();
            event.target.click();
        }
    };

    const renderLinkContent = (item) => {
        const submenuIcon = item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>;
        const badge = item.badge && <Badge value={item.badge} />;

        return (
            <>
                <i className={item.icon}></i>
                <span>{item.label}</span>
                {submenuIcon}
                {badge}
                <Ripple />
            </>
        );
    };

    const renderLink = (item, i) => {
        const content = renderLinkContent(item);

        if (item.to) {
            return (
                <NavLink
                    aria-label={item.label}
                    onKeyDown={onKeyDown}
                    role="menuitem"
                    className="p-ripple"
                    activeClassName="router-link-active router-link-exact-active"
                    to={item.to}
                    onClick={(e) => onMenuItemClick(e, item, i)}
                    end
                    target={item.target}
                >
                    {content}
                </NavLink>
            );
        } else {
            return (
                <a
                    tabIndex="0"
                    aria-label={item.label}
                    onKeyDown={onKeyDown}
                    role="menuitem"
                    href={item.url}
                    className="p-ripple"
                    onClick={(e) => onMenuItemClick(e, item, i)}
                    target={item.target}
                >
                    {content}
                </a>
            );
        }
    };

    const items = props.items?.map((item, i) => {
        const active = activeIndex === i;
        const styleClass = classNames(item.badgeStyleClass, {
            "layout-menuitem-category": props.root,
            "active-menuitem": active && !item.to,
        });

        return (
            <li className={styleClass} key={i} role="none">
                {props.root ? (
                    <>
                        <div className="layout-menuitem-root-text" aria-label={item.label}>
                            {item.label}
                        </div>
                        <AppSubmenu items={item.items} onMenuItemClick={props.onMenuItemClick} />
                    </>
                ) : (
                    <>
                        {renderLink(item, i)}
                        <CSSTransition
                            classNames="layout-submenu-wrapper"
                            timeout={{ enter: 1000, exit: 450 }}
                            in={active}
                            unmountOnExit
                        >
                            <AppSubmenu items={item.items} onMenuItemClick={props.onMenuItemClick} />
                        </CSSTransition>
                    </>
                )}
            </li>
        );
    });

    return items ? (
        <ul className={props.className} role="menu">
            {items}
        </ul>
    ) : null;
};

const findParentAndChildLabelByPath = (items, path, parentLabel = null) => {
    for (const item of items) {
        if (item.to === path) {
            // Found the exact item, return both parent and child labels
            if (parentLabel === "Home") {
                parentLabel = item.label
            }
            return { parentLabel, childLabel: item.label };
        }
        if (item.items) {
            // Search children with current item.label as parentLabel
            const found = findParentAndChildLabelByPath(item.items, path, item.label);
            if (found) {
                return found;
            }
        }
    }
    return null;
};


export const AppMenu = (props) => {
    const location = useLocation();
    const [activeMenuLabel, setActiveMenuLabel] = useState("");
    var {setMenuRootName} =useContext(AppDB)

    useEffect(() => {
        const label = findParentAndChildLabelByPath(props.model, location.pathname);
        if (label) {
            // setActiveMenuLabel(label);
            setMenuRootName(label)
            // console.log("Initial menu label (on load):", label);
        }
    }, [location.pathname, props.model]);

    const handleMenuItemClick = ({ item }) => {
        if (item?.label) {
            setActiveMenuLabel(item.label);
            // console.log("Menu changed to:", item.label);
        }
    };

    return (
        <div className="layout-menu-container">
            <AppSubmenu
                items={props.model}
                className="layout-menu"
                onMenuItemClick={handleMenuItemClick}
                root={true}
                role="menu"
            />
        </div>
    );
};
